/**
 * @generated SignedSource<<47c3069e91ca33dd72d3e422dc522c17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type PageTreeInitialData_query$data = {
  readonly currentPage?: {
    readonly blank: boolean | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null;
            readonly createdDate: {
              readonly value: string;
            } | null;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null;
            } | null;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
                readonly version: {
                  readonly number: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly status: PTGraphQLPageStatus | null;
            readonly subType: string | null;
            readonly title: string | null;
            readonly type: string | null;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null;
            readonly createdDate: {
              readonly value: string;
            } | null;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null;
            } | null;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
                readonly version: {
                  readonly number: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly status: PTGraphQLPageStatus | null;
            readonly subType: string | null;
            readonly title: string | null;
            readonly type: string | null;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly homepageRootPageTree?: {
    readonly blank: boolean | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly rootPageTree?: {
    readonly blank: boolean | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly space: {
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTree?: {
      readonly blank: boolean | null;
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly createdDate: {
        readonly value: string;
      } | null;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly hasChildren: boolean;
      readonly hasInheritedRestrictions?: boolean;
      readonly hasRestrictions?: boolean;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly blank: boolean | null;
              readonly createdDate: {
                readonly value: string;
              } | null;
              readonly hasChildren: boolean;
              readonly hasInheritedRestrictions?: boolean;
              readonly hasRestrictions?: boolean;
              readonly id: string;
              readonly links: {
                readonly webui: string | null;
              } | null;
              readonly properties: {
                readonly nodes: ReadonlyArray<{
                  readonly id: string | null;
                  readonly key: string | null;
                  readonly value: string | null;
                  readonly version: {
                    readonly number: number | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly status: PTGraphQLPageStatus | null;
              readonly subType: string | null;
              readonly title: string | null;
              readonly type: string | null;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly blank: boolean | null;
              readonly createdDate: {
                readonly value: string;
              } | null;
              readonly hasChildren: boolean;
              readonly hasInheritedRestrictions?: boolean;
              readonly hasRestrictions?: boolean;
              readonly id: string;
              readonly links: {
                readonly webui: string | null;
              } | null;
              readonly properties: {
                readonly nodes: ReadonlyArray<{
                  readonly id: string | null;
                  readonly key: string | null;
                  readonly value: string | null;
                  readonly version: {
                    readonly number: number | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly status: PTGraphQLPageStatus | null;
              readonly subType: string | null;
              readonly title: string | null;
              readonly type: string | null;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PageTreeInitialData_query";
};
export type PageTreeInitialData_query$key = {
  readonly " $data"?: PageTreeInitialData_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageTreeInitialData_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v1 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v2 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v3 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "title"
},
v6 = {
  "kind": "ScalarField",
  "name": "status"
},
v7 = {
  "kind": "ScalarField",
  "name": "value"
},
v8 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v9 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v10 = {
  "kind": "ScalarField",
  "name": "blank"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "subType"
},
v13 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v7/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v15 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v17 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ]
  },
  {
    "concreteType": "PTPageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v16/*: any*/)
    ]
  }
],
v18 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v17/*: any*/)
},
v19 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v17/*: any*/)
},
v20 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      },
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/)
        ]
      }
    ]
  },
  (v18/*: any*/),
  (v19/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v17/*: any*/)
  }
],
v21 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v19/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeHomepageTreeVariant"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includePageTree"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isSuperAdmin"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "paginationLimit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ptStatuses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "spaceKey"
    }
  ],
  "kind": "Fragment",
  "name": "PageTreeInitialData_query",
  "selections": [
    {
      "condition": "includePageTree",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "currentPage",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "contentId"
            },
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "concreteType": "PTPage",
          "kind": "LinkedField",
          "name": "ptpage",
          "plural": false,
          "selections": (v20/*: any*/)
        },
        {
          "alias": "rootPageTree",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "concreteType": "PTPage",
          "kind": "LinkedField",
          "name": "ptpage",
          "plural": false,
          "selections": (v21/*: any*/)
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "spaceKey"
        }
      ],
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "homepage",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ]
        },
        {
          "concreteType": "OperationCheckResult",
          "kind": "LinkedField",
          "name": "operations",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "operation"
            },
            {
              "kind": "ScalarField",
              "name": "targetType"
            }
          ]
        },
        {
          "condition": "includeHomepageTreeVariant",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v3/*: any*/)
              ],
              "concreteType": "PTPage",
              "kind": "LinkedField",
              "name": "pageTree",
              "plural": false,
              "selections": (v20/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "condition": "includeHomepageTreeVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "homepageRootPageTree",
          "args": [
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "concreteType": "PTPage",
          "kind": "LinkedField",
          "name": "ptpage",
          "plural": false,
          "selections": (v21/*: any*/)
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "e072e9ecc0309e9692fa9b3d05207e59";

export default node;
